<template>
  <!-- <div>
    此份問卷已失效。
  </div>-->
  <SurveyFrontEnd content="此份問卷已失效。" />
</template>

<script>
import SurveyFrontEnd from '@/components/SurveyFrontEnd.vue';

export default {
  name: 'Invaild',
  components: {
    SurveyFrontEnd
  }
};
</script>
